import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    current_path: ''
  },
  mutations: {
    update(state, config) {
      Object.keys(config).map(item => {
        state[item] = config[item]
      })
    }
  },
  actions: {}
})
